var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconResponsible02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 107",
    style: {
      enableBackground: "new 0 0 100 107"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#231F20;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17,99.2c-0.2,4.7-3.4,7.8-7.6,7.8c-2.2,0-4.1-0.9-5.6-2.5c-1.2-1.4-1.9-3.2-1.9-5.2c0-2.1,0.8-4,2.3-5.5 c1.4-1.4,3.2-2.1,5.4-2.1c3,0,5.4,1.5,6.5,4h-2.6c-1-1.2-2.4-1.9-4-1.9c-1.4,0-2.7,0.5-3.7,1.5c-1,1.1-1.6,2.5-1.6,3.9 c0,1.6,0.5,3,1.5,4c1,1.1,2.4,1.7,3.8,1.7c2.2,0,4-1.2,5.1-3.6H7.8v-2.1H17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3,106.7H17l5.8-14.8h2.1l5.8,14.8h-2.4l-1.6-4.3h-5.7L19.3,106.7z M23.8,94.7l-2.1,5.6h4.2L23.8,94.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5,106.7V91.9h3.2l4.3,11.5l4.3-11.5h3.1v14.8h-2l0.1-12.8l-4.8,12.8h-1.5l-4.8-12.8l0.1,12.8H31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8,107c-2.2,0-4-0.8-5.5-2.4c-1.4-1.5-2.1-3.3-2.1-5.5c0-2,0.8-3.9,2.2-5.4c1.5-1.4,3.3-2.2,5.4-2.2 c3.5,0,6.4,2.3,7.4,5.9h-3.9c-0.8-1.5-2-2.2-3.4-2.2c-2.2,0-3.9,1.7-3.9,3.9c0,2.4,1.8,4.2,3.9,4.2c1.4,0,2.6-0.8,3.4-2.1h3.9 C62.2,104.8,59.4,107,55.8,107z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8,106.7h-4l5.7-14.8h3l5.7,14.8h-4l-0.7-2.1h-4.9L66.8,106.7z M70,96.8l-1.5,4.7h2.9L70,96.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5,106.7V91.9h4.9c1.6,0,2.8,0.1,3.7,0.8c1.3,0.9,2,2.3,2,4.1c0,2.4-1.2,4.2-3.4,4.8l3.6,5.1h-4.5l-2.8-4.8v4.8 L77.5,106.7L77.5,106.7z M81.8,98.7c1.8,0,2.7-0.5,2.7-1.8c0-1.2-0.8-1.7-2.4-1.7h-1v3.5L81.8,98.7L81.8,98.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1,106.7V91.9h8v3.3h-4.4v2.4h4.4v3.3h-4.4v2.6h4.4v3.3H90.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M95.5,51.2c-0.4-0.2-0.8-0.4-1.3-0.4c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0-0.2,0h-0.2c-0.1,0-0.3,0-0.4,0h-29 c-2,0-3.7,1.7-3.7,3.7c0,2,1.7,3.7,3.7,3.7h11.2c0.4,0,0.7,0.3,0.7,0.7c0,0.2-0.1,0.4-0.3,0.5c-6.2,3.3-14.1,5.3-22.8,5.3 c-2.1,0-4.2-0.1-6.2-0.3v8.4c1.8,0.1,3.5,0.2,5.3,0.2c12.1,0,23.1-3,31.3-7.8l0,0c0.1-0.1,0.2-0.1,0.3-0.1c0.4,0,0.7,0.3,0.7,0.7 c0,0.1,0,0.1,0,0.2l-1.7,4.7c-0.9,2.5,0.4,5.2,2.8,6.1c0.5,0.2,1.1,0.3,1.6,0.3c1.9,0,3.7-1.2,4.4-3.1l6.2-16.9 C98.7,54.8,97.6,52.3,95.5,51.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53,19.4c8.7,0,16.8,2,22.9,5.4c0,0,3.9,2.8,5.8,0.1c2.1-3.1-2.1-5.1-2.1-5.1c-7.7-3.6-17.2-5.7-27.5-5.7 c-1.8,0-3.6,0.1-5.3,0.2v5.5C48.8,19.5,50.8,19.4,53,19.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.5,0C4.9,0,2,2.9,2,6.5v71.4c0,3.6,2.9,6.5,6.5,6.5h38.3V72.7C23.7,71,5.9,58.6,5.9,43.5c0-15.1,17.9-27.5,40.9-29.2V0 C46.8,0,8.5,0,8.5,0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4,42c0,11.1,12.7,20.4,29.3,22.3V19.8C30.1,21.6,17.4,30.9,17.4,42z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconResponsible02);
export default __webpack_public_path__ + "static/media/icon-responsible-02.1b49522ed20db70f81e8ff8888575ef1.svg";
export { ForwardRef as ReactComponent };